module.exports = __webpack_public_path__ + "static/logo-93c3f972614b7b85de53a4d252840cf4.svg";